import { useTranslation } from "react-i18next";
import Layout from "@/components/feature/Layout";
import SEO from "@/components/feature/SEO";
import ServicePageLayout from "./components/ServicePageLayout";
import { energiaUPSData } from "@/mocks/services";

export default function EnergiaUPSPage() {
  const { t } = useTranslation("home");

  return (
    <Layout>
      <SEO
        title="Energía UPS y Plantas de Emergencia | Ventra Core León"
        description="Soluciones de energía de respaldo UPS, baterías, monitoreo remoto, plantas de emergencia y auditorías eléctricas en León, Guanajuato. Protege tu infraestructura."
        keywords="energía UPS, plantas de emergencia, baterías de respaldo, monitoreo remoto, protección eléctrica, León Guanajuato, centros de datos"
        canonical="https://ventracore.com.mx/energia-ups"
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "@id": "https://ventracore.com.mx/energia-ups#service",
            "serviceType": "Energía UPS y Plantas de Emergencia",
            "provider": { "@id": "https://ventracore.com.mx/#organization" },
            "areaServed": {
              "@type": "City",
              "name": "León",
            },
            "description": "Soluciones de energía de respaldo UPS y plantas de emergencia en León, Guanajuato.",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": "https://ventracore.com.mx/",
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Servicios",
                "item": "https://ventracore.com.mx/servicios",
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "Energía & UPS",
                "item": "https://ventracore.com.mx/energia-ups",
              },
            ],
          },
        ]}
      />
      <ServicePageLayout
        title={t("servicesPage.energyTitle")}
        subtitle={t("servicesPage.energySubtitle")}
      >
        <div className="max-w-5xl mx-auto">
          <p className="text-sm md:text-base text-text-muted leading-relaxed text-center mb-10 md:mb-14">
            {energiaUPSData.intro}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {energiaUPSData.features.map((f) => (
              <div
                key={f.title}
                className="bg-surface rounded-lg p-5 md:p-6 border border-transparent hover:border-brandgreen/20 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-brandgreen/10 rounded-md mb-4">
                  <span className="w-6 h-6 flex items-center justify-center text-brandgreen">
                    <i className={f.icon} />
                  </span>
                </div>
                <h4 className="text-base font-bold text-magenta mb-2">
                  {f.title}
                </h4>
                <p className="text-sm text-text-muted leading-relaxed">
                  {f.description}
                </p>
              </div>
            ))}
          </div>

          <p className="text-sm text-text-muted text-center mt-10 md:mt-14">
            {energiaUPSData.contact}
          </p>
        </div>
      </ServicePageLayout>
    </Layout>
  );
}